/** @format */

import { useTranslation } from 'react-i18next';
import { Grid, TextField, Box } from '@mui/material';
import { CheckCircleOutline } from '@mui/icons-material';
// import {ArrowRight} from '@mui/icons-material';
import useAuth from 'src/hooks/useAuth';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Breadcrumb from 'src/components/Breadcrumb';
import { VALIDATE_REGEX } from 'src/constants';
import clsx from 'clsx';
import { useDispatch } from 'src/store';
import { changePassword } from 'src/slices/users';
import { Button } from 'src/components';
import Page from 'src/components/Page';

const Access = props => {
  const { user } = useAuth();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const goBack = () => {
    navigate('/profile');
  };
  const { t } = useTranslation();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errorMsg, setErrorMsg] = useState(undefined);
  const [successMsg, setSuccessMsg] = useState(undefined);
  const [specialCase, setSpecialCase] = useState(false);
  const [upperCase, setUpperCase] = useState(false);
  const [number, setNumber] = useState(false);
  const [length, setLength] = useState(false);

  const isValidPassword = [specialCase, upperCase, number, length].every(i => i) && password === confirmPassword;

  useEffect(() => {
    if (user) {
      setUserData(user);
    }
  }, [user]);

  const savePassword = () => {
    let payload = {
      uuid: user.uuid,
      password: password
    };
    if (isValidPassword) {
      dispatch(changePassword(payload)).then(response => {
        if (response) {
          setSuccessMsg(t('access.successMsg'));
          setTimeout(reset, 3000);
        }
      });
    }
  };

  const reset = () => {
    setConfirmPassword('');
    setPassword('');
    setSuccessMsg(undefined);
    setSpecialCase(false);
    setUpperCase(false);
    setNumber(false);
    setLength(false);
  };

  const passwordValidate = e => {
    const { value } = e.target;
    setPassword(value);
    validateHighlight(value);
    if (confirmPassword && confirmPassword === value) {
      let validation = regexValidate(value);
      if (validation) {
        setErrorMsg(undefined);
      } else {
        setErrorMsg(t('access.reqPasswordNotFulfil'));
      }
    } else if (confirmPassword) {
      setErrorMsg(t('access.passwordNotMatch'));
    } else if (!confirmPassword) {
      setErrorMsg(undefined);
    }
  };

  const confirmPasswordValidate = e => {
    const { value } = e.target;
    setConfirmPassword(value);
    if (password === value) {
      let validation = regexValidate(value);
      if (validation) {
        setErrorMsg(undefined);
      } else {
        setErrorMsg(t('access.reqPasswordNotFulfil'));
      }
    } else {
      setErrorMsg(t('access.passwordNotMatch'));
    }
  };

  const regexValidate = value => {
    return VALIDATE_REGEX.password.test(value);
  };

  const validateHighlight = value => {
    let specialCaseLetters = /[!,;`~'":{}<>^/@#$%&*?|\\[\])(+=._-]/;

    if (value.match(specialCaseLetters)) {
      setSpecialCase(true);
    } else {
      setSpecialCase(false);
    }

    // Validate capital letters
    let upperCaseLetters = /[A-Z]/g;
    if (value.match(upperCaseLetters)) {
      setUpperCase(true);
    } else {
      setUpperCase(false);
    }

    // Validate numbers
    let numbers = /[0-9]/g;
    if (value.match(numbers)) {
      setNumber(true);
    } else {
      setNumber(false);
    }

    // Validate length
    if (value.length >= 8) {
      setLength(true);
    } else {
      setLength(false);
    }
  };

  const breadcrumbData = [
    {
      title: t('profile.title'),
      link: '/profile',
      options: [
        {
          title: t('profile.title'),
          link: '/profile'
        },
        {
          title: t('common.personalData'),
          link: '/personaldata'
        },
        {
          title: t('common.access'),
          link: '/access'
        }
      ]
    },
    {
      title: t('common.access')
    }
  ];

  return (
    <Page title={t('common.access')}>
      <section className="main_content profile">
        <Breadcrumb data={breadcrumbData} additionalClasses="container--narrow" />
        <div className="container container--narrow">
          {/* <h4 className="page_subtitle">{t('profile.subTitle')}</h4> */}
          <Grid className="personal-data-container">
            <h2 className="page_title">{t('common.access')}</h2>
            <Grid className="personal-data__card">
              <h4 className="sub_head">{t('access.username')}</h4>
              <Grid className="personal-data__card-head">
                <Grid>
                  <TextField
                    id="standard-full-width-username"
                    label={t('access.username')}
                    value={userData?.preferred_username || ''}
                    fullWidth
                    className="personal-data__text-field"
                    margin="normal"
                    InputProps={{
                      disabled: true
                    }}
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid className="personal-data__card">
              <h4 className="sub_head">{t('access.email')}</h4>
              <Grid className="personal-data__card-head">
                <Grid>
                  <TextField
                    id="standard-full-width-email"
                    label={t('access.email')}
                    value={userData?.email || ''}
                    fullWidth
                    className="personal-data__text-field"
                    margin="normal"
                    InputProps={{
                      disabled: true
                    }}
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid className="personal-data__card">
              <h4 className="sub_head">{t('access.changepassword')}</h4>
              <Grid className="personal-data__card-head">
                <Grid>
                  <TextField
                    type="password"
                    id="standard-full-width-password"
                    label={t('access.NewPassword')}
                    placeholder={t('access.NewPassword')}
                    fullWidth
                    className="personal-data__text-field"
                    margin="normal"
                    InputLabelProps={{
                      shrink: true
                    }}
                    value={password}
                    onChange={e => passwordValidate(e)}
                  />
                </Grid>
                <Grid className="personal-data__instruction-wrapper">
                  <div className={clsx('personal-data__instruction', length && 'personal-data__instruction--valid')}>
                    <CheckCircleOutline
                      className={clsx(
                        'personal-data__instruction-icon',
                        length && 'personal-data__instruction-icon--valid'
                      )}
                    />{' '}
                    {t('access.instruction_1')}
                  </div>
                  <div className={clsx('personal-data__instruction', upperCase && 'personal-data__instruction--valid')}>
                    <CheckCircleOutline
                      className={clsx(
                        'personal-data__instruction-icon',
                        upperCase && 'personal-data__instruction-icon--valid'
                      )}
                    />{' '}
                    {t('access.instruction_2')}
                  </div>
                  <div className={clsx('personal-data__instruction', number && 'personal-data__instruction--valid')}>
                    <CheckCircleOutline
                      className={clsx(
                        'personal-data__instruction-icon',
                        number && 'personal-data__instruction-icon--valid'
                      )}
                    />{' '}
                    {t('access.instruction_3')}
                  </div>
                  <div
                    className={clsx('personal-data__instruction', specialCase && 'personal-data__instruction--valid')}>
                    <CheckCircleOutline
                      className={clsx(
                        'personal-data__instruction-icon',
                        specialCase && 'personal-data__instruction-icon--valid'
                      )}
                    />{' '}
                    {t('access.instruction_4')}
                  </div>
                </Grid>
                <Grid>
                  <TextField
                    type="password"
                    id="standard-full-width-re-password"
                    label={t('access.repeatNewPassword')}
                    placeholder={t('access.repeatNewPassword')}
                    fullWidth
                    className="personal-data__text-field"
                    margin="normal"
                    InputLabelProps={{
                      shrink: true
                    }}
                    value={confirmPassword}
                    onChange={e => confirmPasswordValidate(e)}
                  />
                </Grid>

                {errorMsg && (
                  <Box sx={{ mt: 2 }}>
                    <span className="personal-data__error-msg">{errorMsg}</span>
                  </Box>
                )}
                {successMsg && (
                  <Box sx={{ mt: 2 }}>
                    <span className="personal-data__success-msg">{successMsg}</span>
                  </Box>
                )}
              </Grid>
            </Grid>
            <Grid>
              <div className="personal-data__footer-btn">
                <Button disabled={!isValidPassword} onClick={savePassword} label={t('common.button.save')} />
                <Button onClick={goBack} secondary label={t('personalData.Abortbtn')} />
              </div>
            </Grid>
          </Grid>
        </div>
      </section>
    </Page>
  );
};

export { Access };
